module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (237).2b87ce65.jpg";